import { Component, OnInit, ViewChild } from '@angular/core';
import { DataService, AppService, LocalStorageService } from '../../../../service';
import { Router } from '@angular/router';
import { now } from 'moment';
import { ModalController, NavParams, NavController, PickerController } from '@ionic/angular';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import * as dd from 'dingtalk-jsapi'; // 引入钉钉jsapi

import { PickerOptions } from "@ionic/core";
import { CorpSelectComponent } from '../../corp-select/corp-select.component';

import { PersonSelectModalComponent } from '../person-select-modal/person-select-modal.component';
import { FormSelectModalComponent } from '../form-select-modal/form-select-modal.component';
import { MultiSelectModalComponent } from '../../multi-select-modal/multi-select-modal.component';
import { NewPageSelectComponent } from '../../new-page-select/new-page-select.component';
import { any } from '@amcharts/amcharts4/.internal/core/utils/Array';
import { TranslateService } from '@ngx-translate/core';
import { OrgCascaderComponent } from '../../org-cascader/org-cascader.component';
import { SystemCodeMap } from '../../../configs/system-code-map';

@Component({
  selector: 'riskmap-filter-modal',
  templateUrl: './riskmap-filter-modal.component.html',
  styleUrls: ['./riskmap-filter-modal.component.scss'],
})
export class RiskmapFilterModalComponent implements OnInit {
  queryCriterias = [];
  query;
  // 默认筛选条件
  defaultBL = null;
  defaultDivision = null;
  defaultRegion = null;
  defaultProject = null;
  startTime = null;
  endTime = null;
  defaultCheckTable = null;
  courseType = null;
  maintanenceDept = null;
  needFormSelection;
  courseTypeList = [];
  courseTypeListTrans = [];
  maintenanceDeptList = [];
  maintenanceDeptListTrans = [];
  currentDateString = new Date().toISOString();
  workAreaList = [];
  // 选表的名字
  inspectionForm;
  // 选表要传递出的数据,第一个是type，第二个是id
  selectCheckTable = [];
  // 选表的数据源
  formPickerDate = [];
  queryCompany;
  isAction;
  queryForm;

  inspectionTaskStatusList = [];
  observationStatusList = [];
  gmpFindStatusList = [];
  actionStatusList = [];
  inspectionMethodList = [];
  dataScopeList = [];
  gmpTypeList = [];
  gmpCorrectiveStatusList = []
  noOrg;
  isHidden;
  isArea;
  isbbso;
  hasType;
  isGmpFinding;
  isGmpInspection;
  gmpStatusList;
  isGmpCorrective;
  locationsList = [];

  constructor(
    public dataService: DataService,
    public appService: AppService,
    public router: Router,
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalController: ModalController,
    public localStorageService: LocalStorageService,
    public pickerController: PickerController,
    private translateService: TranslateService,
  ) {
    let params = this.navParams.data;
    this.query = params.query;
    this.isAction = params.isAction;
    this.isHidden = params.isHidden;
    this.isbbso = params.isbbso;
    this.noOrg = params.noOrg;
    this.isArea = params.isArea;
    this.hasType = params.hasType;
    this.isGmpFinding = params.isGmpFinding;//gmp发现列表
    this.isGmpInspection = params.isGmpInspection;//gmp审核列表
    this.isGmpCorrective = params.isGmpCorrective; //gmp整改列表
  }

  ngOnInit() {
    // 设置标题
    document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
    // 获取状态code
    // this.getTaskStatusList();
    this.getDataScopeList();
    this.getLocationsList();
  }

  // 获取状态code
  async getTaskStatusList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.codesChildrenOf('_SYS_PL1').subscribe(res => {
        if (res && res.STATUS === 0) {
          const statusData = res.DATA[0].childCodes;
          if (this.isbbso) {
            const filterType1 = ['_SYS_PL1_1', '_SYS_PL1_5', '_SYS_PL1_7'];
            this.inspectionTaskStatusList = statusData.filter(child => filterType1.includes(child.code));
          } else {
            const filterType2 = ['_SYS_PL1_8', '_SYS_PL1_1', '_SYS_PL1_I', '_SYS_PL1_E', '_SYS_PL1_7', '_SYS_PL1_3'];
            this.inspectionTaskStatusList = statusData.filter(child => filterType2.includes(child.code));
          }

          const filterType4 = ['_SYS_PL1_7', '_SYS_PL1_8', '_SYS_PL1_1', '_SYS_PL1_I', '_SYS_PL1_E', '_SYS_PL1_3'];
          this.observationStatusList = statusData.filter(child => filterType4.includes(child.code));

          const filterType5 = ['_SYS_PL1_1', '_SYS_PL1_5', '_SYS_PL1_7'];
          this.actionStatusList = statusData.filter(child => filterType5.includes(child.code));

          const filterType6 = ['_SYS_PL1_7', '_SYS_PL1_1', '_SYS_PL1_I', '_SYS_PL1_E', '_SYS_PL1_3'];
          this.gmpFindStatusList = statusData.filter(child => filterType6.includes(child.code));

          const filterType7 = ['_SYS_PL1_8', '_SYS_PL1_1', '_SYS_PL1_I', '_SYS_PL1_E', '_SYS_PL1_7', '_SYS_PL1_3', '_SYS_PL1_J', '_SYS_PL1_T2'];
          this.gmpStatusList = statusData.filter(child => filterType7.includes(child.code));


          const filterType8 = ['_SYS_PL1_1', '_SYS_PL1_3', '_SYS_PL1_5', '_SYS_PL1_7', '_SYS_PL1_I'];
          this.gmpCorrectiveStatusList = statusData.filter(child => filterType8.includes(child.code));
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  // 获取数据范围（按模块多选）
  async getDataScopeList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.codesChildrenOf(SystemCodeMap.riskHeatModuleScope).subscribe(res => {
        if (res && res.STATUS === 0) {
          this.dataScopeList = res.DATA[0].childCodes;
          resolve();
        } else {
          this.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  /** 把以逗号拼接的模块码翻译成当前语言的名称，用顿号拼接显示 */
  getModuleScopeNames(str: string): string {
    if (!str) { return ''; }
    return str.split(',').filter(Boolean).map(code => this.translateCode(code, this.dataScopeList)).filter(Boolean).join('、');
  }

  // 重置条件
  resetSearchFilters() {
    Object.keys(this.query).forEach((item, index) => {
      this.query[item] = null;
    });
  }

  cancel() {
    this.modalController.dismiss();
  }

  confirm() {
    this.modalController.dismiss({ query: this.query });
  }

  async selectOrg() {
    history.pushState(null, null, document.URL);
    const modal = await this.modalController.create({
      component: OrgCascaderComponent,
      componentProps: {
        selected: this.query.businessLine,
      },
      showBackdrop: true,
      backdropDismiss: true
    });
    modal.onDidDismiss().then(res => {
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
      if (res.data) {
        this.query.businessLine = res.data;
        this.getLocationsList();
      }
    });
    return await modal.present();
  }

  // 更新开始时间格式
  changeStartTimeFormat(event) {
    let selectedDate = event.detail.value;
    if (selectedDate) {
      if (this.endTime && new Date(selectedDate).getTime() - new Date(this.endTime).getTime() > 0) {
        this.appService.toastTip('shared_components.filter_modals.start_time_not_lg_end_time', true);
      } else {
        this.startTime = new Date(selectedDate).toISOString();
      }
    }
  }
  // 更新结束时间格式
  changeEndTimeFormat(event) {
    let selectedDate = event.detail.value;
    if (selectedDate) {
      if (this.startTime && new Date(selectedDate).getTime() - new Date(this.startTime).getTime() < 0) {
        this.appService.toastTip('shared_components.filter_modals.end_time_not_lg_start_time', true);
      } else {
        this.endTime = new Date(selectedDate).toISOString();
      }
    }
  }

  // 检查方式
  async selectInspectionMethod() {
    let i = 0;
    if (this.query.inspectionMethod) {
      this.inspectionMethodList.forEach((res, index) => {
        if (res.code === this.query.inspectionMethod) {
          i = index;
          return;
        }
      })
    }
    let options: PickerOptions = {
      buttons: [
        {
          text: this.translateService.instant('shared_components.filter_modals.cancel_button_key'),
          role: 'cancel'
        },
        {
          text: this.translateService.instant('common.confirm'),
          handler: (value: any) => {
            this.query.inspectionMethod = value.inspectionMethod.value;
          }
        }
      ],
      columns: [
        {
          name: 'inspectionMethod',
          options: this.getOptionListOfTranslate(this.inspectionMethodList),
          selectedIndex: i
        }
      ]
    };
    let picker = await this.pickerController.create(options);
    return picker.present();
  }

  // 检查类型
  async selectInspectionCategory() {
    const modal = await this.modalController.create({
      component: MultiSelectModalComponent,
      showBackdrop: true,
      backdropDismiss: true,
      componentProps: {
        code: '_SYS_BL',
        selectedOptions: this.query.inspectionCategory,
        modalTitle: this.translateService.instant('shared_components.filter_modals.audit_type_display_key'),
        inspectionEHS: true
      }
    });
    modal.onDidDismiss().then(res => {
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.filter_modals.audit_type_display_key');
      if (res.data) {
        this.query.inspectionCategory = res.data.selectedOptions;
      }
    });
    return await modal.present();
  }

  // 将查询到的code转化为下拉组件可以识别的形式
  getOptionListOfTranslate(list) {
    let options = [];
    list.forEach(item => {
      var lang = localStorage.getItem("APP_LANG");
      switch (lang) {
        case 'zh_CN':
          options.push({ text: item.code_desc_zh, value: item.code });
          break;
        case 'en_US':
          options.push({ text: item.code_desc_en, value: item.code });
          break;
        case 'zh_TW':
          options.push({ text: item.code_desc_tr, value: item.code });
          break;
        case 'vi':
          options.push({ text: item.code_desc_vi, value: item.code });
          break;
        case 'km':
          options.push({ text: item.code_desc_km, value: item.code });
          break;
        default:
          options.push({ text: item.code_desc_en, value: item.code });
          break;
      }
    });
    return options;
  }

  // 选择数据范围（按模块多选）
  async selectDataScope() {
    return this.openMultiCodeModal(
      'moduleScopes',
      this.dataScopeList,
      'shared_components.filter_modals.data_scope'
    );
  }

  private getMultiSelectDisplayField(): string {
    const lang = this.localStorageService.getStore('APP_LANG');
    switch (lang) {
      case 'zh_CN': return 'code_desc_zh';
      case 'zh_TW': return 'code_desc_tr';
      case 'en_US': return 'code_desc_en';
      case 'vi': return 'code_desc_vi';
      case 'km': return 'code_desc_km';
      default: return 'code_desc_zh';
    }
  }

  private async openMultiCodeModal(field: string, optionList: any[], titleKey: string) {
    history.pushState(null, null, document.URL);
    const pageTitle = this.translateService.instant(titleKey);
    const modal = await this.modalController.create({
      component: NewPageSelectComponent,
      componentProps: {
        pageTitle,
        placeholderMessage: pageTitle,
        optionList,
        displayField: this.getMultiSelectDisplayField(),
        valueField: 'code',
        multiSelect: true,
        needFilterSearch: false,
        cancelText: 'common.cancel',
        confirmText: 'common.confirm',
        selected: this.query[field] ? String(this.query[field]).split(',').filter(Boolean) : [],
      },
      showBackdrop: true,
      backdropDismiss: true
    });
    modal.onDidDismiss().then(res => {
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
      if (Array.isArray(res.data)) {
        this.query[field] = res.data.length > 0 ? res.data.join(',') : null;
      }
    });
    return await modal.present();
  }

  async selectTypeStatus() {
    let i = 0;
    if (this.query.type) {
      if (this.isGmpInspection) {
        this.gmpTypeList.forEach((res, index) => {
          if (res.code === this.query.type) {
            i = index;
            return;
          }
        })
      } else {
        this.dataScopeList.forEach((res, index) => {
          if (res.code === this.query.type) {
            i = index;
            return;
          }
        })
      }

    }
    let options: PickerOptions = {
      buttons: [
        {
          text: this.translateService.instant('shared_components.filter_modals.cancel_button_key'),
          role: 'cancel'
        },
        {
          text: this.translateService.instant('common.confirm'),
          handler: (value: any) => {
            this.query.type = value.typeObj.value;
          }
        }
      ],
      columns: [
        {
          name: 'typeObj',
          options: this.getOptionListOfTranslate(this.isGmpInspection ? this.gmpTypeList : this.dataScopeList),
          selectedIndex: i
        }
      ]
    };

    let picker = await this.pickerController.create(options);
    return picker.present();
  }

  async selectWorkingArea() {
    if (!this.query.businessLine) {
      this.appService.toastTip('shared_components.filter_modals.select_upper_org_structure', true);
      return;
    };
    let i = 0;
    console.log(this.query);
    if (this.query.workArea) {
      this.workAreaList.forEach((res, index) => {
        if (res.code === this.query.workArea) {
          i = index;
          return;
        }
      })
    }
    let options: PickerOptions = {
      buttons: [
        {
          text: this.translateService.instant('shared_components.filter_modals.cancel_button_key'),
          role: 'cancel'
        },
        {
          text: this.translateService.instant('common.confirm'),
          handler: (value: any) => {
            this.query.workArea = value.workAreaFilter.value;
          }
        }
      ],
      columns: [
        {
          name: 'workAreaFilter',
          options: this.getWorkTypeStatusOptionList(),
          selectedIndex: i
        }
      ]
    };

    let picker = await this.pickerController.create(options);
    return picker.present();
  }

  translateCode(code, translationList: any[]) {
    let lang = this.localStorageService.getStore("APP_LANG");
    let data = null;
    for (const item of translationList) {
      if (code === item.code) {
        switch (lang) {
          case 'zh_CN':
            data = item.code_desc_zh;
            break;
          case 'zh_TW':
            data = item.code_desc_tr;
            break;
          case 'en_US':
            data = item.code_desc_en;
            break;
          case 'vi':
            data = item.code_desc_vi;
            break;
          case 'km':
            data = item.code_desc_km;
            break;
        }
        return data ? data : item.code_desc_zh;
      }
    }
    return '';
  }

  getWorkTypeStatusOptionList() {
    let options = [];
    this.workAreaList.forEach(item => {
      options.push({ text: item.spaceName, value: item.id });
    });
    return options;
  }

  translateCodeArea(id, dataList: any[]) {
    for (const item of dataList) {
      if (id === item.id) {
        return item.spaceName;
      }
    }
    return '';
  }

  getWorkTypeClassification() {
    const param = {
      pagingTool: {
        currentPage: 1,
        pageSize: 100
      },
      queryCriterias: [{
        condition: "=",
        connection: "and",
        isValueADigital: false,
        key: "es.org_id",
        value: this.query.businessLine.id
      }],
      queryOrderBies: [{
        columnName: "id",
        orderType: "desc"
      }]
    };
    this.dataService.getSpaceList(param).subscribe(res => {
      if (res && res['STATUS'] === 0) {
        this.workAreaList = res['DATA'];
      }
    });
  }
  employeeProcess(emp) {
    if (emp) {
      return '[' + emp.code + '] ' + emp.full_name;
    }
    return;
  }

  formProcess(form) {
    if (form) {
      return form.formName;
    }
    return;
  }

  async selectInspector(selectedPerson) {
    const modal = await this.modalController.create({
      component: PersonSelectModalComponent,
      showBackdrop: true,
      backdropDismiss: true,
      componentProps: {
        selectPerson: selectedPerson,
        modalTitle: this.translateService.instant('shared_components.common.inspector'),
        source: 'auto',
      }
    });
    modal.onDidDismiss().then(res => {
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.inspector');
      if (res.data) {
        this.query.inspector = res.data.person;
      }
    });
    return await modal.present();
  }

  // 选择表格
  async selectForm(selectedForm) {
    const modal = await this.modalController.create({
      component: FormSelectModalComponent,
      showBackdrop: true,
      backdropDismiss: true,
      componentProps: {
        selectedForm: selectedForm,
        modalTitle: this.translateService.instant('shared_components.filter_modals.check_table_table'),
        excludeMedical: true,
      }
    });
    modal.onDidDismiss().then(res => {
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
      if (res.data) {
        this.query.formSelector = res.data.form;
      }
    });
    return await modal.present();
  }

  getTranslateCode(str) {
    let trans = '';
    if (str) {
      const codes = str.split(',');
      codes.forEach((code, index) => {
        trans += this.translateService.instant(code);
        if (index !== codes.length - 1) {
          trans += ',';
        }
      });
    }
    return trans;
  }

  // 获取地点列表
  async getLocationsList(): Promise<any> {
    const that = this;
    const promise = new Promise<void>((resolve, reject) => {
      that.dataService.getSpaceOfOrgId(this.query.businessLine ? this.query.businessLine.id : null, 'type/').subscribe(res => {
        if (res && res.STATUS === 0) {
          that.locationsList = res.DATA;
          resolve();
        } else {
          that.appService.toastTip(res.MSG, false);
          reject();
        }
      });
    });
    return promise;
  }

  // 获取层级的地点名称
  getLocationLevelName(space) {
    let spaceName = '';
    if (space && this.locationsList) {
      const namesPath = this.findNodePathById(this.locationsList, space.id);
      spaceName = (namesPath && namesPath.length) > 0 ? namesPath.join(' / ') : '';
    }
    return spaceName;
  }
  findNodePathById(tree, targetId, names = []) {
    // 遍历当前层级的每个节点
    for (const node of tree) {
      // 将当前节点的名字添加到路径名称数组中
      names.push(node.spaceName);
      // 如果当前节点的ID匹配目标ID，则返回路径名称数组
      if (node.id === targetId) {
        return names;
      }
      // 如果当前节点有子节点，则递归查找子树
      if (node.childSpace && node.childSpace.length > 0) {
        // 递归调用，传递当前节点的子树、目标ID以及当前路径
        const foundNames = this.findNodePathById(node.childSpace, targetId, names.slice());
        // 如果在子树中找到了目标ID，则返回找到的名称路径，否则回溯
        if (foundNames) {
          return foundNames;
        }
      }
      // 当前节点不是目标节点且其子节点也没有找到目标ID，从路径中移除当前节点的名字，进行回溯
      names.pop();
    }
    // 如果遍历完当前层级仍未找到目标ID，则返回null
    return null;
  }
  // 选择地点
  async selectLocations() {
    history.pushState(null, null, document.URL);
    const modal = await this.modalController.create({
      component: CorpSelectComponent,
      componentProps: {
        pageTitle: this.translateService.instant('shared_components.filter_modals.locations'),
        placeholderMessage: this.translateService.instant('shared_components.filter_modals.locations'),
        originalOptionList: this.locationsList,
        selected: this.query.spaceId,
        showInvalid: true
      },
      showBackdrop: true,
      backdropDismiss: true
    });
    modal.onDidDismiss().then(res => {
      // 设置标题
      document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.filter');
      if (res.data) {
        this.query.spaceId = res.data;
      }
    });
    return await modal.present();
  }  
}
